<template>
  <div class="header-container">
    <div class="logo" @click="goIndex">
      <img src="@/assets/images/logo.png" class="imagecontain" />
    </div>
    <el-menu
      :default-active="defaultActive"
      mode="horizontal"
      :router="true"
      text-color="#333333"
      active-text-color="#4AB344"
    >
      <template v-for="(item, index) in menus">
        <el-submenu :index="item.route" :key="index" v-if="item.children">
          <template slot="title">{{item.name}}</template>
          <el-menu-item :index="child.route" v-for="(child, idx) in item.children" :key="idx">{{child.name}}</el-menu-item>
        </el-submenu>
        <el-menu-item :index="item.route" :key="index" v-else>{{item.name}}</el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultActive: '/',
      menus: [
        {
          name: '首页',
          route: '/'
        },
        {
          name: '项目概况',
          route: '/generalization'
        },
        {
          name: '项目动态',
          route: '/dynamic'
        },
        // {
        //   name: '一期精彩',
        //   route: '/wonderful',
        //   children: [
        //     {
        //       name: '景点分布',
        //       route: '/wonderful/scene'
        //     },
        //     {
        //       name: '交通指引',
        //       route: '/wonderful/traffic'
        //     },
        //     {
        //       name: '游玩攻略',
        //       route: '/wonderful/play'
        //     },
        //     {
        //       name: '酒店住宿',
        //       route: '/wonderful/hotel'
        //     },
        //     {
        //       name: '特色美食',
        //       route: '/wonderful/food'
        //     }
        //   ]
        // },
        {
          name: '产业发展',
          route: '/industry',
          children: [
            {
              name: '产业规划',
              route: '/industry/plan'
            },
            {
              name: '产业合作',
              route: '/industry/cooperation'
            },
            {
              name: '战略伙伴',
              route: '/industry/partner'
            }
          ]
        },
        {
          name: '恒百年',
          route: '/shop/index'
        },
        {
          name: '联系我们',
          route: '/contact/us'
        }
        // {
        //   name: '联系我们',
        //   route: '/contact',
        //   children: [
        //     {
        //       name: '联系我们',
        //       route: '/contact/us'
        //     },
        //     {
        //       name: '招聘英才',
        //       route: '/contact/sign'
        //     }
        //   ]
        // }
      ]
    }
  },
  mounted() {
    
  },
  methods: {
    goIndex() {
      this.$router.push({
        path: '/'
      })
    }
  },
  watch: {
    '$route.path': {
      handler(path) {
        this.defaultActive = path
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .header-container {
    width: 1200px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    /deep/ .el-menu {
      border: none;
      .el-menu-item {
        transition: unset;
        &.is-active {
          border: none !important;
        }
      }
      .el-submenu {
        &.is-active {
          .el-submenu__title {
            border-bottom-color: transparent !important;
          }
        }
      }
    }
  }
  .logo {
    width: 98px;
    height: 40px;
  }
</style>